import PropTypes from 'prop-types';

export const SubjectWellMark = ({ className }) => {
  return (
    <svg
      width="105"
      height="11"
      viewBox="0 0 105 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H105L95.7526 9.75229C94.9973 10.5489 93.9478 11 92.8501 11H0V4Z"
        fill="#03BCD4"
      />
      <path
        d="M13.228 2.1086C13.228 2.1086 11.8177 2.00015 10.196 2.00015C8.5641 1.9903 8 2.45366 8 3.686V4.26767C8 5.32255 8.53388 5.42114 9.61171 5.60845C9.94413 5.66761 11.4551 5.93379 11.9386 6.03238C12.2912 6.09153 12.3617 6.27885 12.3617 6.53518V7.04783C12.3617 7.67879 12.13 7.80695 11.3242 7.80695H8.01007L8 8.88156C8 8.88156 9.85347 8.99 11.4752 8.99C13.1172 8.99986 13.6511 8.48721 13.6511 7.25486V6.35772C13.6511 5.48029 13.3589 5.10566 12.3617 4.91834C11.8883 4.82961 9.82325 4.45498 9.82325 4.45498C9.43039 4.37611 9.31959 4.3071 9.31959 4.01134V3.8043C9.31959 3.22264 9.47069 3.1832 10.1557 3.1832H13.2179L13.228 2.1086Z"
        fill="black"
      />
      <path
        d="M16.9419 6.90981V2.04945H15.6526V7.13656C15.6526 8.23088 16.3375 8.97029 17.6068 8.97029H19.5811C20.8503 8.97029 21.5353 8.23088 21.5353 7.13656V2.04945H20.2459V6.90981C20.2459 7.56049 19.9538 7.85625 19.2588 7.85625H17.9291C17.234 7.85625 16.9419 7.56049 16.9419 6.90981Z"
        fill="black"
      />
      <path
        d="M23.8824 8.95057H27.6699C28.9392 8.95057 29.6241 8.30975 29.6241 7.21543V6.51546C29.6141 5.89436 29.191 5.50001 28.5866 5.30283C29.1205 5.10566 29.463 4.74089 29.473 4.15922V3.77473C29.473 2.68041 28.7881 2.04945 27.5188 2.04945H23.8824V8.95057ZM25.1718 5.90422H27.3476C28.0427 5.90422 28.3851 6.10139 28.3851 6.60419V6.90981C28.3851 7.56049 28.093 7.85625 27.398 7.85625H25.1718V5.90422ZM28.234 4.19865C28.234 4.69159 27.9016 4.83947 27.2267 4.84933H25.1718V3.13391H27.2469C27.9419 3.13391 28.234 3.33108 28.234 3.98176V4.19865Z"
        fill="black"
      />
      <path
        d="M31.3788 8.89142C31.3788 8.89142 32.3559 8.99986 33.6252 8.99986C34.8843 9.00972 35.7708 8.48721 35.7708 7.26472V2.04945H34.4814V6.91967C34.4814 7.57035 34.1893 7.86611 33.4942 7.86611H31.3788V8.89142Z"
        fill="black"
      />
      <path
        d="M38.1147 8.95057H43.101V7.78724H39.4041V6.01266H42.6577V4.87891H39.4041V3.15363H43.111V2.04945H38.1147V8.95057Z"
        fill="black"
      />
      <path
        d="M50.4169 2.07902C50.4169 2.07902 48.9563 2.00015 47.0827 2.00015C45.8236 1.9903 45.1889 2.78885 45.1889 3.88317V7.01826C45.1889 8.11258 45.8236 9.00972 47.0827 8.99986C48.7549 8.99986 50.4169 8.90128 50.4169 8.90128L50.4069 7.86611H47.6065C46.9115 7.86611 46.569 7.52105 46.569 6.87037V4.03106C46.569 3.38038 46.9115 3.13391 47.6065 3.13391H50.4069L50.4169 2.07902Z"
        fill="black"
      />
      <path
        d="M57.9531 2.04945H52.1207V3.13391H54.3973V8.95057H55.6866V3.13391H57.9531V2.04945Z"
        fill="black"
      />
      <path
        d="M69.6727 7.72808H69.3906L68.4236 2.04945H66.4593L65.4923 7.72808H65.2103L64.1425 2.04945H62.702C62.702 2.04945 64.0519 8.42806 64.1224 8.78297C64.1526 8.91113 64.2231 8.97029 64.3339 8.97029H66.4593C66.55 8.97029 66.6507 8.92099 66.6709 8.80269C66.7112 8.56608 67.3962 3.8043 67.3962 3.8043H67.4868C67.4868 3.8043 68.1718 8.56608 68.2121 8.80269C68.2322 8.92099 68.333 8.97029 68.4236 8.97029H70.5491C70.6599 8.97029 70.7304 8.91113 70.7606 8.78297C70.8311 8.42806 72.1809 2.04945 72.1809 2.04945H70.7405L69.6727 7.72808Z"
        fill="black"
      />
      <path
        d="M74.1382 8.95057H79.1244V7.78724H75.4276V6.01266H78.6812V4.87891H75.4276V3.15363H79.1345V2.04945H74.1382V8.95057Z"
        fill="black"
      />
      <path d="M81.4216 8.95057H86.297V7.81681H82.7109V2.04945H81.4216V8.95057Z" fill="black" />
      <path d="M88.1246 8.95057H93V7.81681H89.4139V2.04945H88.1246V8.95057Z" fill="black" />
    </svg>
  );
};

SubjectWellMark.propTypes = {
  className: PropTypes.shape({}),
};

SubjectWellMark.defaultProps = {
  className: null,
};
